import React, { Fragment } from 'react'
import { FormattedMessage } from 'react-intl'
import { AdditionalInfo, Button, List, Text } from 'src/Components'
import Phone from 'src/Components/Phone'
import Email from 'src/Components/Email'
import { IconCheckCircle } from 'src/Components/Icon'

import styles from './Step.module.scss'

const CMASectionComplete = ({ agent, phone, close }) => (
  <Fragment>
    <Text size='xxxl'>
      <IconCheckCircle />
    </Text>
    <AdditionalInfo.Heading>
      <FormattedMessage
        id='Homeowner.cmaWizard.complete.headline'
        defaultMessage="We're checking on your value"
      />
    </AdditionalInfo.Heading>
    <Text color='quiet' size='s' paragraph>
      <FormattedMessage
        id='Homeowner.cmaWizard.complete.body'
        defaultMessage="We're looking into the value of your home and will notify you when there's an update. Feel free to get in touch with {agent} if you have any questions in the meantime."
        values={{ agent: agent.firstName }}
      />
    </Text>
    <List.Bulleted.Inline>
      <Phone value={phone} />
      <Email value={agent.email} />
    </List.Bulleted.Inline>
    <Button.Group className={styles.buttonGroup}>
      <Button onClick={close}>
        <FormattedMessage
          id='Homeowner.cmaWizard.complete.yesButton'
          defaultMessage='Close'
        />
      </Button>
    </Button.Group>
  </Fragment>
)

export default CMASectionComplete
